module.exports = __webpack_public_path__ + "img/modules_icon.8c783805.png";